export default __webpack_public_path__ + "static/media/popcorn.61c32bf5.png";